module.exports = __webpack_public_path__ + "static/img/strona_021.b1d87c28.jpg";